import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'molecules/Modal';
import {
  getPriceBasedOnShowPriceWithTaxFlag,
  getTotalPriceWithoutTaxForCustomItem,
  getItemValueElseNA,
  getModifiers,
  getEmptyObjectforNull,
} from 'common/utilities/utils';
import { ModalTemplate } from './CustomisationModalTemplate';
import { updateItemQuantityAction, setUserLastActiveTime } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { useDispatch, useSelector } from 'react-redux';
import { addFavouriteItemToCart } from 'organisms/AccountPage/accountPageUtils';

export const CustomizableItemModal = props => {
  const {
    filteredPreviousData,
    tenantData,
    dname,
    cardId,
    categoryId,
    categoryName,
    categoryUrl,
    itemCount,
    availability,
    imageName,
    itemFoodlineId,
    customizable,
    isFavouriteMenu = false,
    cartData,
    clickHandler,
    handleClose,
    foodId,
    isEditSelection,
    headerText,
    pricewithouttax,
  } = props;

  const dispatch = useDispatch();
  const { flatResponse: { productMapById = {} } = {} } =
    getEmptyObjectforNull(useSelector(({ menuReducer }) => menuReducer)) ?? {};
  const { tenantId } = tenantData;
  const [customizableFoodItemsList, SetCustomizableFoodItemsList] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const { currencyConversionFactor, currencySymbol, componentOptions } = tenantData;
  const { web: { global: { showPriceWithTax = false } = {} } = {} } = componentOptions ?? {};
  const CustomizeModalProps = {
    id: 'CustomizedModal',
    role: 'dialog',
    modalTitleId: 'SELECT QUANTITY',
    show: true,
    classNames: 'CustomizedModal',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: handleClose,
    modalTitle: headerText,
  };

  const [dispatchCount, setDispatchCount] = useState(-1);
  const [dispatchList, setDispatchList] = useState([]);

  const dispatchUpdateItemQuantityAction = () => {
    dispatch(
      updateItemQuantityAction(
        {
          params: {
            basketId: cartData?.id,
            basketLineItemId: dispatchList[dispatchCount]?.basketLineItemId,
          },
          tenantId: tenantId,
        },
        { quantity: dispatchList[dispatchCount]?.quantity },
      ),
    );
  };

  const updateCartHandler = () => {
    if (cartData?.id && tenantId) {
      const customizableFoodItemsListArr = Object.values(customizableFoodItemsList);
      const tempList = customizableFoodItemsListArr.filter(
        foodItem => foodItem?.previousQty !== foodItem?.quantity && foodItem,
      );
      setDispatchList(tempList);

      // RENDEV-7289 Analytics add to cart event implimention
      const dataForAnalytics = customizableFoodItemsListArr?.[0];
      const { foodItems, unitPrice, quantity } = dataForAnalytics ?? {};
      let itemVariantsList = `${getModifiers(foodItems?.modGrps)}`;
      const { categoryId: catId = 'NA', categoryName: catName = 'NA' } = productMapById?.[foodItems?.id] ?? {};
      addFavouriteItemToCart({
        item_name: getItemValueElseNA(foodItems?.name),
        item_id: getItemValueElseNA(foodItems?.id),
        item_category: catName,
        price: getItemValueElseNA(unitPrice / currencyConversionFactor),
        item_variant: getItemValueElseNA(itemVariantsList?.trim()),
        item_list_name: catName,
        item_list_id: catId,
        index: 1,
        quantity: quantity,
      });
    }
  };
  const closeModal = () => {
    setDispatchCount(-1);
    handleClose && handleClose();
  };
  const triggerDispatchList = () => {
    if (dispatchList.length === 0 && dispatchCount === 0) {
      closeModal();
    } else if (dispatchList && dispatchList?.length && dispatchCount <= dispatchList.length) {
      dispatchUpdateItemQuantityAction();
      setDispatchCount(dispatchCount + 1);
    }
  };

  useEffect(() => {
    triggerDispatchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchList]);

  useEffect(() => {
    if (dispatchCount === -1) {
      const tempObj = {
        ...customizableFoodItemsList,
      };
      cartData?.foodLines?.forEach(element => {
        if (element?.item?.customizable && element?.item?.id === foodId) {
          const unitPriceWithoutTax = getTotalPriceWithoutTaxForCustomItem(
            element?.amount,
            element?.taxAmount,
            element?.quantity,
          );
          tempObj[element?.id] = {
            tenantId: tenantId,
            basketLineItemId: element?.id,
            quantity: element?.quantity,
            unitPrice: element?.unitPrice,
            unitPriceWithoutTax: unitPriceWithoutTax,
            displayName: element?.item?.displayName,
            modGrps: element?.item?.modGrps,
            maxItemCountPerLineItem: tenantData?.maxItemCountPerLineItem,
            previousQty: element?.quantity,
            foodItems: element?.item,
            catalog: cartData?.catalog,
            categorySelected: categoryId,
          };
        }
      });
      SetCustomizableFoodItemsList(tempObj);
      setDispatchCount(0);
    } else if (dispatchCount === dispatchList.length) {
      closeModal();
      dispatch(setUserLastActiveTime(new Date()));
    } else {
      triggerDispatchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.foodLines]);

  useEffect(() => {
    calculateTotalAmountHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customizableFoodItemsList]);

  const calculateTotalAmountHandler = () => {
    let totAmount = 0;
    Object.values(customizableFoodItemsList).forEach(FooterItems => {
      const price = showPriceWithTax ? FooterItems.unitPrice : FooterItems.unitPriceWithoutTax;
      totAmount = totAmount + FooterItems.quantity * price;
    });
    setTotalAmount((totAmount / currencyConversionFactor).toFixed(2));
  };

  const addNewProductHandler = event => {
    const productDeatils = {
      id: cardId,
      itemCount: itemCount,
      product: {
        productName: dname,
        productImage: imageName,
        productPrice: getPriceBasedOnShowPriceWithTaxFlag(
          availability[0],
          pricewithouttax,
          currencyConversionFactor,
          showPriceWithTax,
        ),
      },
      itemFoodlineId: itemFoodlineId,
    };
    const categoryDetails = {
      catId: categoryId,
      catName: categoryName,
      catUrl: categoryUrl,
    };
    if (isFavouriteMenu) {
      clickHandler(event, productDeatils, customizable, categoryDetails);
    } else {
      clickHandler(event, productDeatils, customizable, categoryDetails);
      handleClose && handleClose();
    }
  };

  const modalTemplate = (
    <Modal {...CustomizeModalProps}>
      <ModalTemplate
        {...props}
        data-testid='ModalTemplate'
        filteredPreviousData={filteredPreviousData}
        addNewProductHandler={addNewProductHandler}
        currencySymbol={currencySymbol}
        currencyConversionFactor={currencyConversionFactor}
        updateCartHandler={updateCartHandler}
        customizableFoodItemsList={customizableFoodItemsList}
        SetCustomizableFoodItemsList={SetCustomizableFoodItemsList}
        totalAmount={totalAmount}
        calculateTotalAmountHandler={calculateTotalAmountHandler}
        isEditSelection={isEditSelection}
        handleClose={handleClose}
      />
    </Modal>
  );
  return ReactDOM.createPortal(modalTemplate, document.getElementById('modal-popups'));
};
